export interface BrawlerBuild {
  starPower: string;
  gadget: string;
  gear1: string;
  gear2: string
}

export enum BuildType {
  STAR_POWERS = "Star Powers",
  GADGETS = "Gadgets",
  GEARS = "Gears",
}
